import { Injectable } from '@angular/core';
import { ApiClientConstant } from '@cureskin/api-client';
import { InstantCheckup, RegimenClass } from '@cureskin/api-client/src/server-api';
import { AllocatedRegimen } from '../../app/app-constant-types';

/** One regimen class's required-photo state, rendered as a single "Complete Your Profile" tab. */
export interface CompleteProfileSection {
  regimenClass: RegimenClass;
  checkupsByType: Record<string, InstantCheckup | null>;
}

@Injectable({ providedIn: 'root' })
export class CompleteYourProfileService {

  getProfileClasses(): RegimenClass[] {
    return [ApiClientConstant.Regimen.Class.FACE, ApiClientConstant.Regimen.Class.HAIR];
  }

  /**
   * Orders sections for tab display (lower tier = earlier; FACE before HAIR within a tier). A section
   * is "fillable" while any required photo is missing. Does not mutate the input.
   *   0 fillable + pending chat · 1 fillable + regimen · 2 fillable · 3 all photos present (last)
   */
  orderSections(
    sections: CompleteProfileSection[],
    isFaceChatPending: boolean,
    isHairChatPending: boolean,
    regimens: AllocatedRegimen[],
  ): CompleteProfileSection[] {
    const FACE = ApiClientConstant.Regimen.Class.FACE;

    const tierOf = ({ regimenClass, checkupsByType }: CompleteProfileSection): number => {
      const hasMissingPhoto = Object.values(checkupsByType).some((checkup) => !checkup);
      const hasPendingChat = regimenClass === FACE ? isFaceChatPending : isHairChatPending;
      const hasRegimen = !!regimens?.some((regimen) => regimen?.class === regimenClass);

      if (!hasMissingPhoto) return 3;
      if (hasPendingChat) return 0;
      if (hasRegimen) return 1;
      return 2;
    };
    const faceFirst = (regimenClass: RegimenClass): number => (regimenClass === FACE ? 0 : 1);

    return [...sections].sort((a, b) =>
      tierOf(a) - tierOf(b) || faceFirst(a.regimenClass) - faceFirst(b.regimenClass));
  }
}
